import { gql } from "@apollo/client"

export const TOURNAMENT_MATCH_CREATE = gql`
  mutation TournamentMatchCreate($TournamentMatchCreateInput: TournamentMatchCreateInput!) {
    TournamentMatchCreate(input: $TournamentMatchCreateInput) {
      status {
        success
        name
        detail
      }
    }
  }
`
